import { useNavigate } from "react-router-dom";
import { useParallelPersona } from "../../context/ParallelPersonaContext";
import { useState } from "react";
import "../../styles/ParallelUploadPage.css";
import Header from "../../components/Header";

const ParallelUploadPage = () => {
  const { setDataset } = useParallelPersona();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // Added state for error message

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const validExtensions = [".csv", ".xlsx", ".xls", ".zip"];
      const fileExtension = file.name
        .slice(file.name.lastIndexOf("."))
        .toLowerCase();

      if (!validExtensions.includes(fileExtension)) {
        alert(
          "Invalid file type. Please upload a CSV, XLSX, XLS, or ZIP file."
        );
        setSelectedFile(null);
        return;
      }

      setSelectedFile(file);
      setUploadSuccess(false);
      setErrorMessage(""); // Reset error message on new file selection
    }
  };

  const handleUpload = () => {
    if (!selectedFile) return;

    setIsUploading(true);
    setTimeout(() => {
      if (selectedFile.name === "test_dataset.zip") {
        setDataset(selectedFile.name);
        setUploadSuccess(true);
        setErrorMessage(""); // Clear any previous errors
      } else {
        setUploadSuccess(false);
        setErrorMessage(
          "Unable to process uploaded file. Please try again later."
        );
      }
      setIsUploading(false);
    }, 1500);
  };

  const handleNext = () => navigate("/parallel/region");

  return (
    <div className="upload-page">
      <Header />
      <h2 className="page-title">Upload Survey Dataset</h2>
      <p>
        Please upload a survey dataset. Supported file types:{" "}
        <b>XLSX, XLS, CSV, ZIP</b>.
      </p>

      <input
        type="file"
        accept=".csv,.xlsx,.xls,.zip"
        onChange={handleFileChange}
      />
      {selectedFile && <p>Selected file: {selectedFile.name}</p>}

      <button
        className="next-button"
        onClick={handleUpload}
        disabled={!selectedFile || isUploading}
      >
        {isUploading ? "Uploading..." : "Upload"}
      </button>

      <div aria-live="polite">
        {errorMessage && <p className="error-message">{errorMessage}</p>}{" "}
        {/* Display error message */}
        {uploadSuccess && (
          <div className="upload-summary">
            <p>
              <b>File:</b> {selectedFile.name}
            </p>
            <p>
              Processing complete. The dataset contains <b>878 responses</b> and{" "}
              <b>87 columns</b>. Click "Next" to proceed to region, ethnicity,
              and topic details.
            </p>
            <button className="next-button" onClick={handleNext}>
              Proceed
            </button>
          </div>
        )}
      </div>

      <div className="navigation-buttons">
        <button className="back-button" onClick={() => navigate("/")}>
          Back
        </button>
      </div>
    </div>
  );
};

export default ParallelUploadPage;
